import { Form, Select } from 'antd'
import _ from 'lodash'
import { FC } from 'react'
import { requiredOneElementRules } from '../../../../../constants/forms/validation/rules'

interface FloodsProps {}

const Floods: FC<FloodsProps> = () => {
    const maxNumberOfFloods = 12 // TODO: Нужно сделать запрос в БД с сортировкой по ручьям и выводу одного элемента через пагинацию,
    // так получим максимальное число ручьев

    return (
        <Form.Item name={'floods'} label={'Кол-во ручьев'} rules={requiredOneElementRules}>
            <Select
                options={_.range(1, maxNumberOfFloods + 1).map(x => ({
                    value: '' + x,
                }))}
            />
        </Form.Item>
    )
}

export default Floods
